/**
 * Zendesk Widget CSS customization and accessibility patches
 */
function patchZendeskChatMenuLabel(webWidgetDoc) {
    if (!webWidgetDoc) return;

    const menuButton = webWidgetDoc.querySelector('[data-testid="chat-menu"]')
        || webWidgetDoc.querySelector('button[aria-haspopup="true"][aria-label="Menu"]');
    const chatOptionsMenuLabel = window.zenChatAccessibilityLabels?.chatOptionsMenu || 'Chat options menu';

    if (menuButton && menuButton.getAttribute('aria-label') !== chatOptionsMenuLabel) {
        menuButton.setAttribute('aria-label', chatOptionsMenuLabel);
    }
}

function observeZendeskChatMenuLabel(webWidgetDoc) {
    patchZendeskChatMenuLabel(webWidgetDoc);

    if (webWidgetDoc.__zenChatMenuLabelObserver) return;

    const observer = new MutationObserver(() => patchZendeskChatMenuLabel(webWidgetDoc));
    observer.observe(webWidgetDoc.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label'] });
    webWidgetDoc.__zenChatMenuLabelObserver = observer;
}

{
    let widgetCustomStyle = `
        html{
            margin:10px;
        }
        button:focus {
            outline: 3px solid #000000 !important;
            outline-offset: 3px;
        }
    `;
    let zendeskWidget = setInterval(() => {
        let widgetIframe = document.querySelector('#launcher');
        if(widgetIframe){
            let widgetBody = widgetIframe.contentWindow.document.body;
            let customStyleTag = document.createElement('style');
            customStyleTag.innerHTML = widgetCustomStyle;
            widgetBody.insertAdjacentElement("afterbegin", customStyleTag);
            zE('webWidget:on', 'open', function() {
                setTimeout(() => {
                    let webWidget = document.querySelector("#webWidget").contentWindow.document.body;
                    observeZendeskChatMenuLabel(webWidget);
                    let input =  webWidget.querySelector('[name="chatBox"]') || webWidget.querySelector('input');
                    if (input) input.focus();
                }, 1000);
            });
            clearInterval(zendeskWidget);
        }
    }, 500);
    window.addEventListener('load',function(){
        if(document.querySelector('#launcher')) return;
        setTimeout(() => {
            clearInterval(zendeskWidget);
        }, 10000);
    });
}

function isMobile() {
    const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(navigator.userAgent);
}
  
if (isMobile()) {
    document.body.classList.add('mobile');
} else {
    document.body.classList.add('desktop');
}

function getBroswerDetails() {
  //Checking the user's OS and Browser
  const body = document.body; // Changed from html to body per request
  
  if ((navigator.userAgent).includes("Android")) {
      body.classList.add("android");
  } else if ((navigator.userAgent).includes("Mac")) {
      body.classList.add("mac");
  } else {
      body.classList.add("windows");
  }


  //-- Browser --//
  var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  var isFirefox = typeof InstallTrigger !== 'undefined';
  var isSafari = /constructor/i.test(window.HTMLElement) || (function(p) {
      return p.toString() === "[object SafariRemoteNotification]";
  })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
  var isIE = /*@cc_on!@*/ false || !!document.documentMode;
  var isEdge = !isIE && !!window.StyleMedia;
  var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
  var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
  var isBlink = (isChrome || isOpera) && !!window.CSS;
  
  if (isFirefox) {
      body.classList.add("isFirefox")
  } else if (isChrome) {
      body.classList.add("isChrome")
  } else if (isSafari) {
      body.classList.add("isSafari")
  } else if (isOpera) {
      body.classList.add("isOpera")
  } else if (isIE) {
      body.classList.add("isIE")
  } else if (isEdge) {
      body.classList.add("isEdge")
  } else if (isEdgeChromium) {
      body.classList.add("isEdgeChromium")
  } else {
      body.classList.add("isBlink")
  }
}
getBroswerDetails();

if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
  // true for mobile device
  document.body.classList.add("mobile"); // Changed from html to body
}
